/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/heart_medium'
export default icon
